<template>
  <div class="small-group">
   <div class="content">
     <div :class="['group_list',{seletcard:item._checked}]" v-for="(item,index) in groupList" :key="index" @click='checkGroup(item,index)' >
        <div class="title">{{item.GroupName}}</div>
        <div style="flex:1">
          <div v-if="item.ClassRoomGroupDetails.length>7" class="avatar_list">
            <div class="avatar">
              <div class="more" @click.stop="showMore(item)">更多</div>
            </div>
            <div class="avatar" v-for="(item1, index1) in item.ClassRoomGroupDetails.slice(0,7)" :key="index1">
              <span v-if="item1.Icon">
                <span :class="[{head_position:index1!==0},{king_border:item1.GroupRoleID === 1}]"  class="head"><img :src="item1.Icon"></span>
              </span>
              <span v-else>
                <span :class="[{head_position:index1!==0},{king_border:item1.GroupRoleID === 1}]" :style="{background:item1.Sex?'#4196ff':'#ff8c8c'}"   class="head">{{xy.showName(item1.FullName)}}</span>
              </span>
              <img src="./img/king.png" alt="" class="king-icon" v-if="item1.GroupRoleID === 1">
            </div> 
          </div>
          <div v-else class="avatar_list">
            <div class="avatar avatar_mask" v-for="(item1, index1) in item.ClassRoomGroupDetails" :key="index1">
              <span v-if="item1.Icon">
                <span :class="[{head_position:index1!==0},{king_border:item1.GroupRoleID === 1}]" v-if="index1<16" class="head"><img :src="item1.Icon"></span>
              </span>
              <span v-else>
                <span :class="[{head_position:index1!==0},{king_border:item1.GroupRoleID === 1}]" :style="{background:item1.Sex?'#4196ff':'#ff8c8c'}" v-if="index1<16"  class="head">{{xy.showName(item1.FullName)}}</span>
              </span>
              <img src="./img/king.png" alt="" class="king-icon" v-if="item1.GroupRoleID === 1">
            </div> 
          </div>
        </div>
        <div class="count">
            <div>
              <div class="score">{{item.GroupRank}}</div>
              <div class="text">小组排名</div>
            </div>
            <div>
              <div class="score">{{item.GroupRankingValue}}</div>
              <div class="text">排名积分</div>
            </div>
            <!--<div class="last-div">
              <div style="position:relative">
                <div :class="['score-count',{'dong':item.hasGif}]">
                  {{item.GroupValue}}
                </div>
                <div v-if="item.hasGif" class="all">
                  <img src="./img/all.gif" alt="">
                </div>-->
                <!--<div v-else class="get-count">-->
                  <!-- <img v-if="item.hasGif" src="./img/dong.gif" alt=""> -->
                  <!--<img src="./img/qianbi.png" alt="">
                </div>
              </div>
              <div class="text">小组得分</div>
            </div>-->
            <div>
              <div class="score">{{item.GroupValue}}</div>
              <div class="text">小组得分</div>
            </div>
          </div>
          <div  class="selspn" v-show="item._checked"></div>
     </div>
      <!--modal-->
   </div>

   <van-popup v-model="show" overlay-class="ipad-popup">
     <div class="mask">
        <div class="title">{{checkObj.GroupName}}</div>
        <div  class="avatar_list avatar_listMask">
          <div class="avatar avatarMask " v-for="(item, index1) in checkObj.ClassRoomGroupDetails" :key="index1">
            <span v-if="item.Icon">
              <span :class="[{head_position:index1!==0},{king_border:item.GroupRoleID === 1}]"  class="head"><img :src="item.Icon"></span>
            </span>
            <span v-else>
              <span :class="[{head_position:index1!==0},{king_border:item.GroupRoleID === 1}]" :style="{background:item.Sex?'#4196ff':'#ff8c8c'}"  class="head">{{xy.showName(item.FullName)}}</span>
            </span>
             <img src="./img/king.png" alt="" class="king-icon" v-if="item.GroupRoleID === 1">
          </div> 
        </div>
       <div class="close" @click="show = false">知道了</div>
     </div> 
      <!-- <div class="close" @click="show = false">知道了</div> -->
   </van-popup>
  
    <div :class="['group-bottom',{numsTop:numberKeyWordShow}]"   v-if="!notify">
      <div class="select-all">
        <van-checkbox v-model="checkedAll" shape="round"  @click="selectedAll"></van-checkbox>
        <span>选择全部</span>
      </div>
      <div class="calculation-ing">
        <img class="iconfont" src="./img/del.png" alt="" @click="delBtn">
          <van-number-keyboard
            :show="numberKeyWordShow"
            theme="custom"
            v-model="scoreTotal"
            extra-key=""
            delete-button-text="删除"
            close-button-text="完成"
            @blur="numberKeyWordShow = false"
            safe-area-inset-bottom
            :transition="showTrans"
          />
          <van-field
            class="nums"
            readonly
            clickable
            :value="scoreTotal"
            placeholder="点此输入"
            type="digit"
            @input="changValue"
            @touchstart.native.stop="numberKeyWordShow=true"
          />
        <img class="iconfont" src="./img/add.png" alt=""  @click="addBtn">
      </div>
      <div class="conser-btn" v-if="obj.isEdit"  @click="conserBtn">确认</div>
    </div>
    <!-- 提示框 -->
    <div class="notify" v-if="notify">
      小组分组未完成，分组后可进行评价。
    </div>
  </div>
</template>
<script>
  import { Toast } from 'vant';
  export default {
    name: '',
    data () {
      return {
        showTrans:true,
        showTrue:true,
        numberKeyWordShow:false,
        notify:false,
        num:'1',
        scoreTotal:'1',
        groupList:[],
        options:[],
        show:false,
        checkObj:{},
        checkedAll:false
      }
    },
    watch:{
      num:{
        handler(val){
          this.scoreTotal= val.toString()
        },
        deep:true,
        immediate:true,
        obj:{},
        groupArr:[]
      },
      numberKeyWordShow:{
         handler(val){
        console.log(val)
        },
        deep:true,
      }
    },
    created () {
      this.obj = this.$store.state.evaluation.ipadAverageObj
      this.getGroupData()
      
    },
    mounted () {},
    methods : {
      selectedAll(){
        this.groupList.map(item=>{
          item._checked = this.checkedAll
        })
      },
      showMore(item){
        console.log(item,"???+++---")

        this.show = true
        this.$set(this,'checkObj',item)
                console.log(this.checkObj.ClassRoomGroupDetails)
      },
      changValue(value){
        console.log(value);
      },
      getGroupData(data){
         Toast.loading({
          message: '加载中...',
          className: 'ipad_toast',
          forbidClick: true
        })
        this.isAllChecked=false
        this.groupList=[]
        this.scoreTotal='1'
        this.num='1'
        this.xyapi.get(`${this.$store.state.apiPath}/api/ClassRoomGroupRecord/GetMobileClassRoomRecordGroupInfo`,{
          schoolDistrictID:this.obj.SchoolDistrictID,
          academicSessionID:this.obj.AcademicSessionID,
          classTableGenerateBaseID:this.obj.ClassTableGenerateBaseID,
          coursePlanAID:this.obj.CoursePlanAID,
          coursePlanAIDType:this.obj.CoursePlanAIDType.toString()
        }).then(res=>{
          if(res.success){
            if(res.data.length===0){
              this.notify = true
            }else{
              // 都为静图
              res.data.forEach(item=>{
                item.hasGif=false
              })
            }
            this.groupList=res.data
            if(data){
              this.groupArr = this.$store.state.evaluation.groupArr
              this.$nextTick(()=>{
                 this.groupArr.forEach((item,index)=>{
                  console.log(this.groupList[index]);
                  this.$set(this.groupList[index],'hasGif',item._checked)
                })
              })
            }
          }
          Toast.clear();
        })
      },
      setUp(data){
        data.forEach((item,index)=>{
          this.$set(this.groupList[index],'hasGif',item._checked)
        })

      },
      delBtn(){
        this.num=Number(this.scoreTotal)
        if(this.num>1){
          this.num--
        }else{
          this.num=1
        }
      },
      addBtn(){
        this.num=Number(this.scoreTotal)
        this.num++
      },
      checkGroup(item,index){
        item._checked = !item._checked
        this.$set(this.groupList, index, item)
        // let  num = 0;
       let res =  this.groupList.filter((item)=>{
         return item._checked === true
        })
        if(res.length === this.groupList.length){
          this.checkedAll = true
        }else{
          this.checkedAll = false
        }        
      },
      conserBtn(){
        this.options=[]
        let obj = this.$store.state.evaluation.ipadAverageObj
        for(let i=0,len=this.groupList.length;i<len;i++){
          if(this.groupList[i]._checked){
            this.options.push({
            GroupID:this.groupList[i].GroupID,
            ProgrammeRecordGroupID:this.groupList[i].ProgrammeRecordGroupID,
            GroupValue:this.groupList[i].GroupValue,
            GroupRank:this.groupList[i].GroupRank,
            GroupRankingValue:this.groupList[i].GroupRankingValue,
            AddFraction:Number(this.scoreTotal)
          })
          }
        }
        if(this.options.length<1){
          Toast.fail({message: '请先选择小组。',className: 'ipad_toast'})
          return false
        }
        if(Number(this.scoreTotal)<1){
          Toast.fail({message: '小组评分不能低于1分。',className: 'ipad_toast'})
          return false
        }
         Toast.loading({
          message: '加载中...',
          className: 'ipad_toast',
          forbidClick: true
        })
        this.xyapi.post(`${this.$store.state.apiPath}/api/ClassRoomGroupRecord/CreateClassRoomRecordGroup`,{
          SchoolDistrictID: obj.SchoolDistrictID, 
          AcademicSessionID: obj.AcademicSessionID,
          ClassTableGenerateBaseID: obj.ClassTableGenerateBaseID,
          CoursePlanAID: obj.CoursePlanAID,
          CoursePlanAIDType: obj.CoursePlanAIDType,
          DisciplineID: obj.DisciplineID,
          AcademicYearID: obj.AcademicYearID,
          StudentGradeForStudentYearID: obj.StudentGradeForStudentYearID,
          GroupFraction:this.options
        }).then(res=>{
          if(res.success){
            Toast.success({message: '保存成功。',className: 'ipad_toast' })
            // item._checked
            this.$store.commit('evaluation/changeIpadgroupArr', this.groupList)
            this.getGroupData('contrast')
            this.checkedAll = false
          }
          Toast.clear();
        })
      }
    }
  }
</script>
<style lang='less' scoped>
/deep/ .van-checkbox__icon .van-icon{
  // border-radius:2px !important;
}
/deep/ .van-checkbox__icon{
  font-size: 22px;
}
 /deep/ .van-cell{
  padding:0 10px;
}
/deep/ .van-field__control{
  font-size: 100% !important;
  text-align: center;
}
/deep/ .van-key__wrapper{
  flex-basis: 15% !important;
}
/deep/ .van-number-keyboard{
  z-index: 999 !important;
}
.notify{
  background: #f08d49;
  color: #fff;
  font-size: 16Px;
  text-align: center;
  padding: 10px 0;
}

.small-group{
  padding:10px 0;
  padding-bottom:80px;
  .group{
    display: flex;
    align-items: center;
    margin-bottom:10px;
    .left{
      width:5%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .right{
      width:95%;
      height: 125px;
      background: #fff;
      padding: 15px;
      font-size: 16Px;
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .title{
        width:90%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }
      .content{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-right: 30px;
      }
    }
  }
}
.count{
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  .score{
    font-size: 28Px;
    color: #E28D30;
  }
  .text{
    font-size: 12Px;
    color: #1A1A1A;
  }
  >div{
    margin-right: 20px;
    text-align: center;
  }
  .all>img{
   width:30px; 
   height:30px; 
  }
  .get-count{
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-image:  linear-gradient(149deg,#fad961 10%, #f76b1c 137%);;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      width: 30px;
      height:30px;
    }
  }
  .score-count{
    position: absolute;
    background: #FC8439;
    font-size: 13Px;
    padding:1px 5px;
    height: 18px;
    line-height: 18px;
    color: #fff;
    border-radius: 8px;
    left: 15px;
    top: -2px;
  }
  .dong{
    animation: bounce-down 0.3s linear;
    -webkit-animation: bounce-down 0.3s linear;
  }
//   @keyframes rotate {
//     0% {top:10px;}
//     50% {top:0px;}
//     75% {transform: rotateY(0deg);}
//     100% {transform: rotateY(360deg);}
//   }
//  @-webkit-keyframes rotate {
//     0% {top:10px;}
//     50% {top:0px;}
//     75% {transform: rotateY(0deg);}
//     100% {transform: rotateY(360deg);}
//   }
  @keyframes bounce-down {
    0% {top:10px;}
    50% {top:5px;}
    100% {top:0px;}
  }
  @-webkit-keyframes  bounce-down {
    0% {top:10px;}
    50% {top:5px;}
    100% {top:0px;}
  }
  .last-div{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }
}
 .group-bottom{
    position: fixed;
    bottom:0;
    left: 0;
    right:0;
    height: 66px;
    border-top: 1px solid #eee;
    box-shadow: -1px 1px 4px 0px rgba(171,171,171,0.5);
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding:0 30px;
    background: #fff;
    .iconfont{
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .calculation-ing{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .nums{
        width:85px;
        font-size: 15px;
        color: #333333;
        // margin:0 20px;
      }
      i{
        color:#267dff;
      }
    }
    .conser-btn{
      width: 74px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      background: #267dff;
      border-radius: 40px;
      color:#fff;
      font-size: 14Px;
    }
    .select-all{
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: center;
      color: rgba(0,0,0,0.85);
      display: flex;
      span{
        margin-left:13px;
        color:rgba(0,0,0,0.85);
      }
    }
      
  }
  .content{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .content{
    padding: 0 5px;
    width: 100%;
  }
  .group_list{
    width: 24%;
    height: 175px;
    background: #ffffff;
    border: 1px solid #ffffff;
    border-radius: 4px;
    display:flex;
    flex-direction: column;
    position: relative;
    margin:  5px;
    .title{
      font-size: 16px;
      font-weight: 500;
      color: rgba(26,26,26,0.85);
      margin: 5px 15px;
    }
  }
  .avatar_list{
    display: flex;
    flex-wrap: wrap;
    height:90px;
    // padding:0 1px;
  }
  .avatar_listMask{
    display: flex;
    flex-wrap: wrap;
  }
  .avatar{
    margin: 1px 12px;
    position: relative;
    .king-icon{
      position: absolute;
      right:-16px;
      top:-15px;
      width:38px;
      height:30px;
      transform: rotate(42deg);
    }
  }
  .avatarMask{
    margin: 4px 12px;
    width: 36px;
    height: 36px;
  }

  .head {
    border:1px solid #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    text-align: left;
    border-radius: 50%;
    // background: @blue;
    font-size: 16px;
    color: #fff;
    > img {
      width: 100%;
      height: 100%;
      display: block;
      border-radius: 50%;
    }
  }
  .more{
    border:1px solid #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    text-align: left;
    border-radius: 50%;
     background: rgba(22,119,255,1);
    font-size: 14Px;
    color: #fff;
  }
.heads{
  display: flex;
}
.heads .head_position{
  margin-left:-12px;
}
.king_border{
  border:5px solid gold;
}
.detail-cc-portrait{
    width: 36px;
    height: 36px;
    line-height: 36px;
    background: rgba(41,128,254,1);
    border-radius: 50%;
    text-align: center;
    color: #fff;
    margin:auto;
    font-size: 14px;
}
.seletcard{
  border: 1px #1677FF solid;

}
.selspn {
  width: 31px;
  height: 31px;
  background: url('./img/sel.png');
  background-size: 62px;
  position: absolute;
  bottom: 0px;
  right: 0px;
}
/deep/  .van-popup--center{
  width: 422px;
  height: 422px;
  background: #ffffff;
border-radius: 10px;
box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.2);
}

.mask{
  position: relatve;
  overflow-y:auto;
  height:100%;
  .title{
    font-size: 16px;
    font-weight: 500;
    padding:16px 24px;
    background: #fff;
    z-index: 99999;
    position: fixed;
    top: 0;
    left:0;
    right:0;
  }
   .close{
    position:fixed;
    bottom: 0;
    left:0;
    right: 0;
    height: 49px;
    line-height: 49px;
    font-size: 18px;
    font-weight: 400;
    text-align: center;
    color: #1677ff;
    border-top: 1px solid #e5e5e5;
    z-index: 9999;
    background:#fff;
  }
  .avatar_list{
   
  }
 

}
/deep/ .van-number-keyboard__keys {
  flex:6;
}
/deep/ .van-key__wrapper{
flex-basis:10% !important;
}
/deep/ .van-key{
  height:40px;
  font-size: 20px;
}
.numsTop{
  bottom:100px;
}
/deep/  .van-popup--center {
    padding: 50px 0px;
}



</style>
